module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "四好运动员申报",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailSihaoApply')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "百佳四好运动员申报",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "已申报的四好运动员",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDetailSihaoApplySuccess')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1360b20c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailSihao.vue
// module id = 1379
// module chunks = 0